// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 767.98px) {
    .header-navbar .navbar-header {
        width: 100% !important;
        top: 3px;
    }
}

.dropdown-menu-right {
  right: 0;
  left: auto;
  top: auto;
}

.header-navbar .navbar-header .navbar-brand .brand-text {
  color: #4c3a00 !important;
}

.header-navbar .navbar-header .navbar-brand .brand-logo {
  height: 44px !important;
  width: auto;
  object-fit: contain;
}

/* .navbar-light {
    z-index: 1038 !important;
} */

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhvcml6b250YWwuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJO1FBQ0ksc0JBQXNCO1FBQ3RCLFFBQVE7SUFDWjtBQUNKOztBQUVBO0VBQ0UsUUFBUTtFQUNSLFVBQVU7RUFDVixTQUFTO0FBQ1g7O0FBRUE7RUFDRSx5QkFBeUI7QUFDM0I7O0FBRUE7RUFDRSx1QkFBdUI7RUFDdkIsV0FBVztFQUNYLG1CQUFtQjtBQUNyQjs7QUFFQTs7R0FFRyIsImZpbGUiOiJob3Jpem9udGFsLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJAbWVkaWEgKG1heC13aWR0aDogNzY3Ljk4cHgpIHtcbiAgICAuaGVhZGVyLW5hdmJhciAubmF2YmFyLWhlYWRlciB7XG4gICAgICAgIHdpZHRoOiAxMDAlICFpbXBvcnRhbnQ7XG4gICAgICAgIHRvcDogM3B4O1xuICAgIH1cbn1cblxuLmRyb3Bkb3duLW1lbnUtcmlnaHQge1xuICByaWdodDogMDtcbiAgbGVmdDogYXV0bztcbiAgdG9wOiBhdXRvO1xufVxuXG4uaGVhZGVyLW5hdmJhciAubmF2YmFyLWhlYWRlciAubmF2YmFyLWJyYW5kIC5icmFuZC10ZXh0IHtcbiAgY29sb3I6ICM0YzNhMDAgIWltcG9ydGFudDtcbn1cblxuLmhlYWRlci1uYXZiYXIgLm5hdmJhci1oZWFkZXIgLm5hdmJhci1icmFuZCAuYnJhbmQtbG9nbyB7XG4gIGhlaWdodDogNDRweCAhaW1wb3J0YW50O1xuICB3aWR0aDogYXV0bztcbiAgb2JqZWN0LWZpdDogY29udGFpbjtcbn1cblxuLyogLm5hdmJhci1saWdodCB7XG4gICAgei1pbmRleDogMTAzOCAhaW1wb3J0YW50O1xufSAqL1xuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/_layout/header/horizontal/horizontal.component.css"],"names":[],"mappings":"AAAA;IACI;QACI,sBAAsB;QACtB,QAAQ;IACZ;AACJ;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH,4kCAA4kC","sourcesContent":["@media (max-width: 767.98px) {\n    .header-navbar .navbar-header {\n        width: 100% !important;\n        top: 3px;\n    }\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n  top: auto;\n}\n\n.header-navbar .navbar-header .navbar-brand .brand-text {\n  color: #4c3a00 !important;\n}\n\n.header-navbar .navbar-header .navbar-brand .brand-logo {\n  height: 44px !important;\n  width: auto;\n  object-fit: contain;\n}\n\n/* .navbar-light {\n    z-index: 1038 !important;\n} */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
